$(document).ready(function () {
  // $('.tooltip').tooltipster({
  //   animation: 'fade',
  //   arrow: false,
  //   theme: 'tooltipster-shadow',
  //   zIndex: 60
  // });
});